import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import boothData from '../data/booths.json';
import modalData from '../data/modals.json';
import { Modal } from '../models';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    public footerExpanded = new BehaviorSubject(false);
    public debug = new BehaviorSubject(false);
    public mobileWarningOpen = new BehaviorSubject(false);
    public acquireReady = new BehaviorSubject(false);

    constructor() { }

    public setFooterExpanded(expanded: boolean): void {
        this.footerExpanded.next(expanded);
    }
    public setAcquireReady(bool: boolean): void {
        this.acquireReady.next(bool);
    }

    public setMobileWarningOpen(open: boolean): void {
        this.mobileWarningOpen.next(open);
    }

    public setFooterHeight(): void {
        const footerEl = document.getElementById('footer');
        setTimeout(() => {
            document.documentElement.style.setProperty('--footer-height', `${footerEl.offsetHeight}px`);
        }, 400);
    }

    public initLogs(): void {
        if (
            localStorage.getItem('houdini-debug') !== null
            && localStorage.getItem('houdini-debug') === 'true'
            || window.location.search.indexOf('debug') > -1
        ) {
            console.warn('true!!!', localStorage.getItem('houdini-debug'));
            this.debug.next(true);
            return;
        }

        if (environment.production) {
            const originalconsole = console;
            console.log = function () { };
            console.debug = function () { };
            console.info = function () { };
            console.warn = function () { };
            console.error = function () { };
        }
    }

    public setMedInfoLink(): void {
        let showName = localStorage.getItem(`${environment.showName}-show-name`);
        if (showName) {
            let congressOpt: any = boothData.welcome.congress_opts.find((el: any) => el.show === showName);
            if (congressOpt) {
                const data: Modal = modalData.find(el => el.id === 'medical-info');
                data.iframe = congressOpt.url;
                data.external = congressOpt.external;
            }
        }
    }
}
